import { Component, OnInit, Input } from '@angular/core';
import { AgentDetailsResponse } from '../model/agentDetailsResponse.model';

@Component({
  selector: 'terra-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss']
})
export class SocialLoginComponent implements OnInit {

  isLoading = false;
  isSaved = false;

  @Input()
  model: AgentDetailsResponse;


  get facebookEnabled() {
    return this.model.logins.find(l => l.loginProvider === 'Facebook');
  }
  get googleEnabled() {
    return this.model.logins.find(l => l.loginProvider === 'Google');
  }

  constructor() {}

  ngOnInit() {

  }

}
